import NamedDto from 'modules/base/dto/NamedDto';
import { TbZodiacAquarius } from 'react-icons/tb';

export class DeviceTypeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number[]} */
		this.sensorTypeList = null;
		/** @type {boolean} */
		this.bridge = null;
		/** @type {number} */
		this.project = null;
		/** @type {boolean} */
		this.canRecord = null;
		/** @type {number} */
		this.externalId = null;
	}

	/**
	 * @typedef {Object} _DeviceTypeEditDtoProps
	 * @property {number[]} sensorTypeList
	 * @property {boolean} bridge
	 * @property {number} project
	 * @property {boolean} canRecord
	 * @property {number} externalId
	 * @typedef {import("../NamedDto").NamedDtoProps & _DeviceTypeEditDtoProps} DeviceTypeEditDtoProps
	 */
	/**
	 *
	 * @param {DeviceTypeEditDtoProps} props
	 * @returns {DeviceTypeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.sensorTypeList = props.sensorTypeList;
		this.bridge = props.bridge;
		this.project = props.project;
		this.canRecord = props.canRecord;
		this.externalId = props.externalId;
		return this;
	}
}

export default DeviceTypeEditDto;
